import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 send_sales_rep_user_account_otp: { message: "idle" },
};

export const send_sales_rep_user_account_otp_Slice = createSlice({
 name: "send_sales_rep_user_account_otp",
 initialState,
 reducers: {
  success_send_sales_rep_user_account_otp: (state, action) => {
   state.send_sales_rep_user_account_otp = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_send_sales_rep_user_account_otp: (state, action) => {
   state.send_sales_rep_user_account_otp = { status: app_consts.FAIL, message: action.payload };
  },
  reset_send_sales_rep_user_account_otp: (state) => {
   state.send_sales_rep_user_account_otp = { status: app_consts.IDLE };
  },
  loading_send_sales_rep_user_account_otp: (state) => {
   state.send_sales_rep_user_account_otp = { status: app_consts.LOADING };
  },
 }
});

export const { success_send_sales_rep_user_account_otp, fail_send_sales_rep_user_account_otp, reset_send_sales_rep_user_account_otp, loading_send_sales_rep_user_account_otp } = send_sales_rep_user_account_otp_Slice.actions;

export default send_sales_rep_user_account_otp_Slice.reducer;